import { Component, Inject, Input, OnInit } from '@angular/core';
import { JardinModel } from 'src/app/model/Jardin.model';
import { DimensionesPMEModel } from 'src/app/model/NewFaseEstrategica.model';
import { PmeFaseAnualComponent } from '../../pme-fase-anual.component';
import { apiService } from 'src/app/service/api.service';
import { NewPlanMejoraService } from 'src/app/service/newPlanMejora.service';

@Component({
  selector: 'app-pme-dimensiones-fase-anual',
  templateUrl: './pme-dimensiones-fase-anual.component.html',
  styleUrls: ['./pme-dimensiones-fase-anual.component.css']
})
export class PmeDimensionesFaseAnualComponent implements OnInit {

  @Input() dimensionData : DimensionesPMEModel;
  @Input() estadoData : number;
  @Input() dataJardin : JardinModel;
  @Input() simulacion: boolean;
  @Input() editarFaseA: boolean;

  cargando: boolean;

  //objetivosAreas = new Array<ObjetivosAreaJardinModel>();
  //subdimensiones = new Array<SubdimensionPMEModel>();

  public isCollapsed = true;

  constructor(
    @Inject(PmeFaseAnualComponent) private parentFE: PmeFaseAnualComponent,
    private api: apiService,
    private newPlanMejoraService: NewPlanMejoraService
    ) { }

  ngOnInit(): void {
   // this.objetivosAreas = this.areaData.objetivosAreas;
    //this.subdimensiones = this.dimensionData.subdimensiones;
    this.cargaInicial();
  }

  cargaInicial(){
    this.dataJardin = this.api.dataJardin;
  }

  // addNuevoObjetivo(objetivosAreas): void {
  //   objetivosAreas.push(new ObjetivosAreaJardinModel());
  // }

  // borrarObjetivo(objetivosAreas): void {
  //     Swal.fire({
  //       title: '¿Está seguro que desea borrar el Objetivo?',
  //       showDenyButton: false,
  //       showCancelButton: true,
  //       confirmButtonText: 'Continuar',
  //       cancelButtonText: 'Cancelar',
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         if (objetivosAreas.length == 2 && (objetivosAreas[objetivosAreas.length-1].idObjetivo !=-1 && objetivosAreas[objetivosAreas.length-1].idObjetivo !=null)) {
  //           this.borrarObjetivoBD(objetivosAreas.pop());
  //         } else {
  //           objetivosAreas.pop();
  //         }
  //         Swal.fire({
  //           title: 'Objetivo borrado!',
  //           icon: 'info',
  //           confirmButtonText: 'OK'
  //         })
  //       }
  //     });
  // }

  // borrarObjetivoBD( objetivo : ObjetivosAreaJardinModel){
  //   this.planMejoraService.API_POST_borrarObjetivoFaseEstrategica(this.dataJardin.id,objetivo.idObjetivo).subscribe((response:any) => {
  //   },
  //   (err) => {
  //     console.log(err)
  //   });
  // }
}
